module.exports = __webpack_public_path__ + "static/media/portfolio-1.f61add67.jpg";